import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { DefaultValues, useForm } from "react-hook-form";
import { useTenant } from "@/contexts/tenant-provider";
import { PatientFormMode, PatientValidationConfig, createPatientValidationSchema } from "@/lib/validation/patient-validation";
import { PatientCreate, PatientDetail, PatientUpdate } from "@/types/patient";
export function usePatientForm(mode, initialData, existingPatientData, t0, tenantRequiredFieldsOverride) {
  const $ = _c(12);
  const phoneNumberRequired = t0 === undefined ? true : t0;
  const {
    tenant
  } = useTenant();
  let t1;
  let t2;
  if ($[0] !== existingPatientData || $[1] !== mode || $[2] !== phoneNumberRequired || $[3] !== tenant?.requiredPatientFields || $[4] !== tenantRequiredFieldsOverride) {
    const config = {
      mode,
      tenantRequiredFields: tenantRequiredFieldsOverride ?? tenant?.requiredPatientFields ?? [],
      existingPatientData: existingPatientData ? {
        email: existingPatientData.email ?? null,
        dateOfBirth: existingPatientData.dateOfBirth ?? null,
        externalId: existingPatientData.externalId ?? null,
        address: existingPatientData.address ?? null,
        city: existingPatientData.city ?? null,
        state: existingPatientData.state ?? null,
        zipCode: existingPatientData.zipCode ?? null,
        leadSource: existingPatientData.leadSource ?? null,
        primaryLocationId: existingPatientData.primaryLocationId ?? null
      } : undefined,
      phoneNumberRequired
    };
    const schema = createPatientValidationSchema(config);
    t2 = useForm;
    t1 = zodResolver(schema);
    $[0] = existingPatientData;
    $[1] = mode;
    $[2] = phoneNumberRequired;
    $[3] = tenant?.requiredPatientFields;
    $[4] = tenantRequiredFieldsOverride;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[7] !== initialData) {
    t3 = initialData || {};
    $[7] = initialData;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = t3 as DefaultValues<T>;
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = {
      resolver: t1,
      defaultValues: t4,
      mode: "onBlur"
    };
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const form = t2(t5);
  return form;
}